<template>
  <div>
    <!-- Table section -->
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col class="d-flex" cols="12" md="3" sm="12">
<!--            <v-btn class="mr-6" dark color="blue" elevation="2" text @click="handleCheck(selected)">-->
<!--              {{ $t("check") }}-->
<!--            </v-btn>-->

<!--            <v-btn dark color="red" elevation="2" text>-->
<!--              {{ $t("reject") }}-->
<!--            </v-btn>-->
          </v-col>

          <v-col class="d-flex" cols="6" md="2" sm="6">
            <v-menu
                v-model="menuDateFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="from_date"
                    :label="$t('dateFrom')"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker
                  :first-day-of-week="0"
                  v-model="from_date"
                  @input="menuDateFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col class="d-flex" cols="6" md="2" sm="6">

            <v-menu
                v-model="menuDateTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="to_date"
                    :label="$t('dateTo')"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker
                  :first-day-of-week="0"
                  v-model="to_date"
                  @input="menuDateTo = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col class="d-flex" cols="6" md="2" sm="6">
            <v-text-field
                v-model="search"
                :label="$t('search')"
                single-line
                outlined
                dense
                clearable
            >
            </v-text-field>
          </v-col>

          <v-col class="d-flex" cols="12" md="2" sm="12">
            <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
              <v-icon class="mr-1"> mdi-magnify</v-icon>
            </v-btn>

            <v-btn @click="exportExcel('exportExcel')" outlined>
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172"
                   style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#000000">
                    <path
                        d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path>
                  </g>
                </g>
              </svg>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
          id="exportExcel"
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="listRevolvingCredit"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
      >
        <!-- Header -->
        <template v-slot:progress class="text-center">
          <v-progress-circular indeterminate color="green" :value="50"></v-progress-circular>
        </template>
        <template v-slot:header.drawdown_date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.loading_date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.miller_payment_date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.crop_trader_name="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.miller_name="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.crop_type="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.status="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

        <!-- Body section -->
        <template v-slot:item.drawdown_date="{ item }">{{ item.drawdown_date | dateFormat }}</template>
        <template v-slot:item.loading_date="{ item }">{{ item.loading_date | dateFormat }}</template>
        <template v-slot:item.miller_payment_date="{ item }">{{ item.miller_payment_date | dateFormat }}</template>
        <template v-slot:item.reference="{ item }">{{ item.application }}</template>
        <template v-slot:item.crop_trader_name="{ item }">{{ item.crop_trader_name }}</template>
        <template v-slot:item.miller_name="{ item }">{{ item.miller_name }}</template>
        <template v-slot:item.crop_type="{ item }">{{ item.crop_type_name }}</template>
        <template v-slot:item.total_amount="{ item }">{{ (item.drawdown_amount ? item.drawdown_amount : 0) | formatNumber }} {{ getCurrencySymbol(item.currency_code) }}</template>
        <template v-slot:item.status="{ item }"><v-chip :color="getColor(item.status.toLowerCase())" dark small outlined>{{$t(item.status.toLowerCase()) }}</v-chip></template>

        <!-- Action -->
        <template v-slot:item.action="{ item }">
          <v-btn color="teal white--text" small rounded class="table-action-button" @click="handleView(item)">
            {{ $t('detail')}}
          </v-btn>
        </template>
      </v-data-table>

      <!-- Pagination -->
      <div class="text-center pt-2">
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{
              totalPage
            }}
          </v-col>
          <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
            <v-select
                :label="$t('perPage')"
                v-model="itemsPerPage"
                :items="pageList"
            ></v-select>
          </v-col>

          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
          ></v-pagination>

          <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
            <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
            ></v-text-field>
          </v-col>
        </v-card-actions>
      </div>
    </v-card>
    <!-- End Table section -->

    <!-- Dialog Detail -->
    <revolving-credit-print v-if="dialog" :option="{dialog: dialog, item: revolvingCreditPrint, component: 'revolving'}" @handle-close="handleClose"></revolving-credit-print>

    <!-- Dialog Check -->
    <div class="text-center">
      <v-dialog v-model="dialogCheck" width="500">
        <v-card>
          <v-card-text class="text-center" style="padding: 20px 0;">
            <img src="data:image/png;base64,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" alt="">
            <h2 style="margin: 30px 0;">{{ $t("doYouWantReviewtransaction") }}</h2>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="mr-2" depressed color="primary" @click="handleClickReview(selected)">
              <v-progress-circular
                  v-if="requestDrawdownLoading"
                  indeterminate
                  :width="1"
                  :size="20"
              ></v-progress-circular>
              <span v-else>
                    {{ $t("agree") }}
                </span>
            </v-btn>
            <v-btn rounded depressed color="red" @click="dialogCheck = false">{{ $t("close") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import MainMixin from "../../../mixins/mainMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import _ from "lodash";
import {provider} from "@/service/provider";
import revolvingCreditPrint from "./revolvingCreditPrint";
import axios from "axios";

export default {
  name: "requestDrawDownRevolvingCredit",
  mixins: [MainMixin, OptionDataMixin, ValidatorMixin],
  components: {revolvingCreditPrint},
  data() {
    return {
      dialog: false,
      dialogCheck: false,
      methods: [],
      selected: [],
      requestDrawdownLoading: false,
      revolvingCreditPrint: {},
      headers: [
        {text: "drawdown_date", value: "drawdown_date", filterable: false},
        {text: "loading_date", value: "loading_date", filterable: false},
        {text: "miller_payment_date", value: "miller_payment_date", filterable: false},
        {text: "reference_credit", value: "reference"},
        {text: "crop_trader_credit", value: "crop_trader_name"},
        {text: "miller_credit", value: "miller_name"},
        {text: "crop_type", value: "crop_type"},
        {text: "amount_credit", value: "total_amount"},
        {text: "status", value: "status"},
        {text: "action", value: "action", width: 50, sortable: false}
      ],
    };
  },

  methods: {

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchListRevolvingCredit({
        id: "",
        search: vm.search,
        from_date: vm.from_date,
        to_date: vm.to_date,
        crop_trader_id : vm.crop_trader_id,
        application_no : vm.application_no,
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
      })
    }, 350),

    handleSearch() {
      this.fetchDataTable();
    },

    handleClose(bySubmit){
      this.dialog = false;
      this.revolvingCreditPrint = {};
      if(bySubmit){ this.fetchDataTable(); }
    },

    handleView(item) {
      this.revolvingCreditPrint = item;
      this.dialog = true;
    },

    handleCheck(selected) {
      let vm = this;
      if (selected[0] !== undefined) {
        vm.dialogCheck = true;
        vm.toggleAdd = true;
      } else {
        vm.$notify({
          title: "Error",
          message: vm.$t('pleaseSelect'),
          type: "error",
          duration: 2000
        });
      }
    },

    handleClickReview(selected) {

      let vm = this;
      if(selected[0].id){
        this.requestDrawdownLoading = true;
        let query = {request_drawdown_id: [{id: this.datas.id}]};
        let url = provider.baseURL + provider.reviewRequestDrawdown;

        axios.post(url, query, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {
            this.$notify({
              title: "Successful",
              message: this.$t("success"),
              type: "success",
              duration: 2000
            });
            this.dialog = false;
            this.isConfirmDialog = false;
            this.$emit('handle-close', true);
          }else{
            this.$notify({
              title: "Warning",
              message: res.data.response.message,
              type: "warning",
              duration: 2000
            });
          }

        }).catch(error => console.log(error)).then(() => this.requestDrawdownLoading = false)
      }else{
        vm.$notify({
          title: "Error",
          message: vm.$t('no_data_select'),
          type: "error",
          duration: 2000
        });
        vm.overlay = false;
      }

    }

  },
  computed: {},
  watch: {
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
  },
  created() {
  }
};
</script>